import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  updateProfile,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail
} from 'firebase/auth';
import { auth } from './firebase';
import { getFirestore, doc, setDoc } from 'firebase/firestore';

export const signUp = async (email, password, displayName) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(userCredential.user, { displayName });
    await sendEmailVerification(userCredential.user);

    const db = getFirestore();
    const userDocRef = doc(db, 'users', userCredential.user.uid);
    const user_data = {
      email: userCredential.user.email,
      display_name: userCredential.user.displayName,
      created_at: new Date(),
      in_table_predictor_leagues: [],
      in_match_predictor_leagues: [],
      admin_leagues: [],
    }

    await setDoc(userDocRef, user_data);

    await signOut(auth); // Sign out the user immediately after creating the account
    return { message: 'User created and verification email sent.' };
  } catch (error) {
    throw error;
  }
};

export const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    if (!userCredential.user.emailVerified) {
      throw new Error('EMAIL_NOT_VERIFIED');
    }
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};

export const logout = () => {
  return signOut(auth);
};

export const resendVerificationEmail = async () => {
  const user = auth.currentUser;
  if (user) {
    try {
      await sendEmailVerification(user);
      return true;
    } catch (error) {
      throw error;
    }
  } else {
    throw new Error('No user is currently signed in.');
  }
};

export const sendPasswordResetEmail = async (email) => {
  try {
    await firebaseSendPasswordResetEmail(auth, email);
    return true;
  } catch (error) {
    throw error;
  }
};